import React from 'react';
import { Result } from 'antd';
import { useTranslation } from 'react-i18next';

const FiveHundred = () => {
  const { t } = useTranslation();

  return (
    <Result status="500" title="500" subTitle={t('general.fiveHundred')} />
  );
};

export default FiveHundred;
